<script setup lang="ts">
  import theBreadcrumb from './the-breadcrumb.vue'

  const emit = defineEmits<{
    (e: 'openSidebar'): void,
  }>()

</script>

<template>
  <div class="fixed right-0 top-0 z-10 px-2 px-2 lg:px-4">
    <div class="h-12 flex items-center border-b bg-app">
      <the-breadcrumb />
      <app-button
        class="ml-auto h-8 flex-center pl-2 text-xl lg:hidden"
        @click="emit('openSidebar')">
        <fa-icon icon="i-far-bars" />
      </app-button>
    </div>
  </div>
</template>
